import { useParams } from "@tanstack/react-router";

import { FullPageLoader } from "@/components/fullpage-loader";

import { useGetProjectDetails } from "./hooks/useGetProjectDetails";
import { ProjectDetailsForm } from "./ProjectDetailsForm";

export default function ProjectDetails() {
  const { projectId } = useParams({
    from: "/_auth/_app-shell/projects/$projectId/edit",
  }) as { projectId: string };

  const {
    data: projectDetails,
    error,
    isLoading,
  } = useGetProjectDetails(Number(projectId));

  if (isLoading) {
    return <FullPageLoader />;
  }

  if (error || !projectDetails) {
    return (
      <div className="p-4 text-text-error-primary">
        Failed to load project details.
      </div>
    );
  }

  return (
    <ProjectDetailsForm
      projectDetails={projectDetails}
      projectId={Number(projectId)}
    />
  );
}
